// extracted by mini-css-extract-plugin
export default {"facetMenu":"St-z","fixed":"Tt-z","nonLayerdFacets":"Ut-z","productCount":"Vt-z","facetBack":"Wt-z","arrow":"Xt-z","facetClose":"Yt-z"};